import { render, staticRenderFns } from "./home_image.vue?vue&type=template&id=b2f56074&scoped=true"
import script from "./home_image.vue?vue&type=script&lang=js"
export * from "./home_image.vue?vue&type=script&lang=js"
import style0 from "./home_image.vue?vue&type=style&index=0&id=b2f56074&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f56074",
  null
  
)

export default component.exports